import React from "react";
import styled from "styled-components";

const Circular = styled.div`
  --size: ${(props) => props.size ?? "3.5rem"};
  --fg: #1dcd0e;
  --bg: #f7f7f8;
  --pgPercentage: ${(props) => props.percentage ?? 0};

  width: var(--size);
  height: var(--size);
  border-radius: 50%;

  display: grid;
  place-items: center;
  background: radial-gradient(closest-side, white 85%, transparent 0 99.9%, white 0),
    conic-gradient(var(--fg) calc(var(--pgPercentage) * 1%), var(--bg) 0);

  font-size: calc(var(--size) / 3.5);
  color: var(--fg);

  &::before {
    counter-reset: percentage ${(props) => props.percentage};
    content: counter(percentage) "%";
    color: #808080;
    font-weight: 500;
  }
`;

export const CircleProgressBar = ({ size, percentage }) => {
  return <Circular role="progressbar" percentage={percentage} size={size} />;
};
